import React from 'react';

import ProductOffer from 'model/ProductOffer';

import gfpOfferStore from 'store/state/gfpOffer/gfpOfferStore';
import { useShallow } from 'zustand/react/shallow';
import GfpOffer from 'screens/OfferDetails/components/GfpOffer/GfpOffer';

import { isEmpty } from 'lodash';
import * as S from './GfpOfferList.styled';

type IProps = {
  productOffer: ProductOffer;
  onImageClick?: (images: string[], title: string) => void;
};

export default function GfpOfferList(props: IProps) {
  const { table } = gfpOfferStore(
    useShallow((state) => ({
      table: state.table,
    })),
  );
  const { productOffer, onImageClick } = props;

  if (isEmpty(table.data)) {
    return (
      <S.EmptyListContainer>
        <S.EmptyIconContainer>
          <S.EmptyIcon />
        </S.EmptyIconContainer>
        <S.EmptyTextContainer>
          <S.EmptyTitle>Esta oferta não possui GFP cadastradas!</S.EmptyTitle>
          <S.EmptySubtitle>
            O produtor não disponibilizou este produto para compras por GFP
          </S.EmptySubtitle>
        </S.EmptyTextContainer>
      </S.EmptyListContainer>
    );
  }

  return (
    <S.ListContainer>
      {table.data.map((item) => (
        <GfpOffer 
          key={item.gfpLineId}
          gfpOffer={item} 
          productOffer={productOffer}
          onImageClick={onImageClick}
        />
      ))}
    </S.ListContainer>
  );
}
